import dynamic from "next/dynamic";

const DynamicResultBlock = dynamic(() => import("../ResultBlock/ResultBlock.jsx"), { ssr: false });
const DynamicStartFavoriteModal = dynamic(() => import("./ModalWindows.jsx").then((comp) => comp.StartFavoriteModal), { ssr: false });
const DynamicStartGalleryModal = dynamic(() => import("./ModalWindows.jsx").then((comp) => comp.StartGalleryModal), { ssr: false });
const AuthModal = dynamic(() => import("../../AuthModal/AuthModal.jsx"), { ssr: false });
const UnlockResultsModal = dynamic(() => import("../FakeResult/UnlockResultsModal.jsx"), { ssr: false });
import QueueComponent from "../QueueComponent/QueueComponent.jsx";
import DownLoadModal from "../DownLoadModal/DownloadModal";

export { DynamicResultBlock, DynamicStartFavoriteModal, DynamicStartGalleryModal, AuthModal, UnlockResultsModal, QueueComponent, DownLoadModal };
